<template>
  <div
    :class="['sui-field', `sui-field--${elMode}`, isBlock ? 'is-block' : '', height ? 'has-height' : '']"
    :style="{
      height: repairPx(height),
      width: repairPx(width)
    }"
  >
    <div v-if="showHeader" class="field-header" :style="{ cursor: closeOnBtn ? '' : 'pointer' }" @click="headerClick">
      <div class="field-title-wrap">
        <!-- 默认title可以通过slot[title]覆盖 -->
        <slot name="title">
          <span v-if="title" class="field-title">{{ _locale(title) }}</span>
          <span v-if="subTitle" class="field-sub-title">{{ _locale(subTitle) }}</span>
        </slot>
      </div>
      <div class="field-title-right">
        <div class="header-btns">
          <slot name="title-right">
            <sui-button-group v-if="btns" :btns="btns"></sui-button-group>
          </slot>
        </div>
        <i
          v-if="closable"
          :class="['field-icon', 'el-icon-arrow-up', collapsed ? 'collapsed' : '']"
          @click.stop="collapsed = !collapsed"
        ></i>
      </div>
    </div>
    <template v-if="isEmpty">
      <sui-empty></sui-empty>
    </template>
    <template v-else>
      <!-- elementUI 自带的动画效果 -->
      <el-collapse-transition>
        <div
          v-show="!collapsed"
          class="field-body"
          :style="{
            height: bodyHeight + 'px'
          }"
        >
          <slot></slot>
        </div>
      </el-collapse-transition>
    </template>
    <div class="fixed-bottom">
      <slot name="bottom"></slot>
    </div>
    <sui-loading v-if="hasLoading" :visible="loading"></sui-loading>
  </div>
</template>
<script>
import { find } from 'lodash-es'
import { hasClass, calcEleFitHeight } from '../../utils/dom.js'
export default {
  name: 'SuiField',
  props: {
    /**
     * 关闭或打开的状态 true代表打开，false代表关闭
     * 一般情况不用传值，只有当需要记录field关闭打开的状态时，才传值
     */
    value: {
      type: Boolean,
      default: true
    },
    /**
     * 高度
     * 当指定了高度之后，就会去自动计算body部分的高度，body部分根据内容的多少可能出现滚动条。
     */
    height: {
      type: [String, Number],
      default: null
    },
    // 宽度
    width: {
      type: [String, Number],
      default: null
    },
    /**
     * 标题 & 副标题
     * 可以通过'title'插槽，自定义标题部分内容
     */
    title: {
      type: String,
      default: ''
    },
    // 副标题
    subTitle: {
      type: String,
      default: ''
    },
    /**
     * 标题按钮
     * 标题右上角部分的按钮，可以通过'title-right'插槽，自定义右上角部分内容
     */
    btns: {
      type: Array,
      default: null
    },
    // 是否可关闭
    closable: {
      type: Boolean
    },
    /**
     * 是否构造成block模块，
     * field变成白底，加上内边距等样式。
     */
    isBlock: {
      type: Boolean
    },
    /**
     * field是否展示为空数据状态
     */
    isEmpty: {
      type: Boolean
    },
    /**
     * 是否在加载中
     * 加载文本
     * 加载图标
     * 加载背景色
     */
    loading: {
      type: Boolean
    },
    closeOnBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      collapsed: false,
      bodyHeight: null,
      hasLoading: false
    }
  },
  computed: {
    elMode() {
      return (this.$ELEMENT || {}).$mode || 'easy'
    },
    showHeader() {
      return this.$scopedSlots.title || this.title || this.$scopedSlots.btns || this.btns || this.closable
    }
  },
  watch: {
    collapsed(val) {
      this.$emit('input', !val)
      if (val) {
        this.$emit('close')
      } else {
        this.$emit('open')
      }
    },
    value(val) {
      this.collapsed = !val
    }
  },
  created() {
    this.collapsed = !this.value
    if (this.$options.propsData.loading !== undefined) {
      // 存在loading属性时，则开启sui-loading组件
      this.hasLoading = true
    }
  },
  mounted() {
    this.calcBodyHeight()
  },
  methods: {
    calcBodyHeight() {
      if (this.$el && this.height) {
        let bodyEl = find(this.$el.children, (el) => {
          return hasClass(el, 'field-body')
        })
        this.bodyHeight = bodyEl ? calcEleFitHeight(bodyEl, 'sui-field') : this.height
      }
    },
    headerClick() {
      if (this.closable && !this.closeOnBtn) {
        this.collapsed = !this.collapsed
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SimbartUI/components/basic/SuiField.vue